<template>
  <v-layout>
    <v-flex d-block xs12 py-1 px-3 align-start>
      <v-layout
          :class="{ 'no-value': selectedCountry === null }"
          row
          style="max-height: 74px !important;"
      >
        <v-flex dflex  style="max-width: 130px;max-height: 74px">
          <v-select
              style="max-width: 120px"
              v-model="selectedCountry"
              :items="countries"
              clearable
              single-line
              label="🌎"
              item-text="selectText"
              item-value="countryCallingCodes"
              autocomplete
              :rules="countryCodeRules"
              :prepend-icon="dirty ? null : phone.verified ? 'verified_user' : phone.value? 'error': ''"
              validate-on-blur>
            <template slot="no-data">
              <v-list-tile>
                <v-list-tile-title>
                  {{ $tf('no data') }}
                </v-list-tile-title>
              </v-list-tile>
            </template>
            <template slot="selection" slot-scope="{ item }">
              <span>{{item.countryCallingCodes}}</span>
            </template>
            <template slot="item" slot-scope="{ item }">
              <v-list-tile-avatar class="headline font-weight-light white--text">
                <span :class="`flag-icon flag-icon-${item.cca2LowerCased}`" />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title v-text="item.name" />
                <v-list-tile-sub-title>
                  {{ item.countryCallingCodes }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </v-select>
        </v-flex>
        <v-flex dflex style="max-height: 74px" xs6 sm4 md3>
          <v-form
              ref="form"
              v-model="valid"
              lazy-validation>
          <v-tooltip left>
            <v-text-field
                slot="activator"
                persistent-hint
                :label="$tf('Phone')"
                v-model="phone.currentValue"
                :class="{'input-group--focused': phone.value !== phone.currentValue}"
                :error-messages="errors.collect('phone')"
                v-validate="phone.rules"
                data-vv-name="phone"
                :data-vv-as="$tf('Phone')"
            ></v-text-field>
            <span key="tooltip-msg"
                  v-if="phone.value.length > 0 && phone.value === phone.currentValue && phone.verified">
                  {{$tf('phone_verified')}}
                </span>
            <span v-else-if="phone.value.length > 0"
                  key="tooltip-msg">
                  {{$tf('phone_not_verified')}}
                </span>
            <span key="tooltip-msg" v-else>
                  {{$tf('phone_empty')}}
                </span>
          </v-tooltip>
          </v-form>
        </v-flex>
        <v-flex v-if="inlineActionButtons && (dirty || (phone.value !== '' && !phone.verified))" dflex style="max-height: 74px" xs1>
          <v-tooltip  v-if="dirty" right>
          <v-btn slot="activator" @keypress.enter.stop="submit" @click="submit" icon class="primary mx-auto center" >
            <v-icon>
            save</v-icon></v-btn>
            <span>{{$tf('Save')}}</span>
          </v-tooltip>
          <v-tooltip v-else-if="phone.value !== '' && !phone.verified" right>
          <v-btn slot="activator" icon class="primary mx-auto center" @click="verifyPhone" @keypress.enter.stop="verifyPhone"  >
            <v-icon>send</v-icon></v-btn>
            <span>{{$tf('Verify')}}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
      <v-layout v-if="actionButtons" dflex >
      <v-flex v-if="dirty" xs6 >
        <v-layout wrap class="mt-2">
          <v-flex v-if="phone.value !== ''" xs12 dflex>
            <p>
              {{$tf('ChangePhoneWarning')}} </p>
          </v-flex>
          <v-flex xs4></v-flex>
          <v-flex xs4 class="justify-center" >
            <v-btn @keypress.enter.stop="submit" @click="submit" :block="$vuetify.breakpoint.smAndDown" class="primary mx-auto center" style="width: 200px" >{{$tf('Save')}}</v-btn>
          </v-flex>
          <v-flex xs4></v-flex>
        </v-layout>
      </v-flex>
      <v-flex v-else-if="phone.value !== '' && !phone.verified" xs6>
        <v-layout wrap class="mt-2">
          <v-flex xs4></v-flex>
          <v-flex xs4 class="justify-center" >
            <v-btn :block="$vuetify.breakpoint.smAndDown" class="primary mx-auto center" style="width: 200px" @click="verifyPhone" @keypress.enter.stop="verifyPhone"  >{{$tf('Verify')}}</v-btn>
          </v-flex>
          <v-flex xs4></v-flex>
        </v-layout>
      </v-flex>

    </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import bus from '~/bus.js'
import Api from '~/store/idonia-api/api'
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import countries from '~/assets/countries'
export default {
  name: 'PhoneInput',
  props: {
    inlineActionButtons: {
      type: Boolean,
      default: false
    },
    accountProp: {
      type: Object,
      default: null
    },
    authChannel: {
      type: String,
      default: null
    },
    actionButtons: {
      type: Boolean,
      default: true
    },
    fromDialog: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    dirty () {
      return this.phone.value !== this.phone.currentValue
    }
  },
  data () {
    return {
      accountId: 0,
      valid: null,
      phone: {
        value: '',
        currentValue: '',
        verified: null,
        rules: 'numeric|min:9'
      },
      selectedCountry: '+34',
      countries,
      countryCodeRules: this.phone && this.phone.currentValue ? [v => !!v || this.$tf('Code is required')] : []
    }
  },
  beforeMount () {
    this.countries = this.countries.filter(country => country.countryCallingCodes).map(country => {
      country.selectText = country.cca2 + ' ' + country.countryCallingCodes
      return country
    })
  },
  mounted () {
    if (!this.accountProp) {
      this.resetValues()
    } else {
      this.account = this.accountProp
      this.accountId = this.account.account_id
    }
    window.addEventListener('keydown', this.enterHandler)
  },
  destroyed () {
    window.removeEventListener('keydown', this.enterHandler)
  },
  methods: {
    enterHandler (e) {
      if (e.key === 'Enter' || e.code === 'Enter') {
        if (this.dirty) {
          this.submit()
          e.preventDefault()
          e.stopImmediatePropagation()
        } else if (this.phone.value !== '' && !this.phone.verified) {
          this.verifyPhone()
          e.preventDefault()
          e.stopImmediatePropagation()
        } else if (this.phone.value !== '' && this.phone.verified) {
          bus.$emit('readyToAcceptOptIn')
        }
      }
    },
    resetValues () {
      let phone
      Api.getV2('account').then(response => {
        this.account = response.body.account
        bus.$emit('reload-account', response.body.account, this.authChannel)
        bus.$emit('reloadAccountInfo', this.authChannel)
        this.accountId = response.body.account['account_id']
        this.$store.dispatch('session/saveAccountData', response.body.account)
        this.phone.value = response.body.account.phone || ''
        if (this.phone.value !== '') {
          phone = parsePhoneNumberFromString(response.body.account.phone)
          this.phone.value = phone ? phone.nationalNumber : ''
        }
        this.phone.currentValue = this.phone.value
        if (phone) {
          this.selectedCountry = '+' + phone.countryCallingCode || '+34'
        }
        this.phone.verified = response.body.account['phone_verified'] || false
      })
    },
    submit () {
      if (!this.$refs.form.validate()) {
        let err = {message: this.$tf('Code is required')}
        throw err
      }
      this.$validator.validateAll()
        .then(valid => {
          if (valid) {
            let phone = this.selectedCountry + this.phone.currentValue
            if (!this.phone.currentValue) {
              phone = ''
            }
            Api.putV2('account/' + this.accountId, {data: { phone: phone }})
              .then(() => {
                this.resetValues()
              })
          }
        })
        .catch(error => {
          console.warn('ERROR', error)
        })
    },
    verifyPhone () {
      let verifyDialog = {
        title: this.$tf('Verify SMS sent'),
        type: 'single-string-input',
        props: {
          label: 'SMS Code',
          counter: false,
          minLength: 5,
          aboveText: this.$tf(`We've sent you a SMS, type below the code in it to verify your phone`)
        },
        width: 420,
        actions: {
          cancel: {},
          accept: {
            title: 'Verify',
            callback: code => this.$services.user.verify.phone.check(code)
              .then(() => {
                this.resetValues()
                this.phone.verified = true
                this.$store.dispatch('feedback/addSnack', {
                  text: 'Phone number verified',
                  type: 'success'
                })
                bus.$emit('reload-account')
                bus.$emit('reloadAccountInfo')
              })
              .catch(response => {
                this.phone.verified = false
                this.$store.dispatch('dialog/setValid', false)
                this.$store.dispatch('feedback/addSnack', {
                  text: 'Invalid code',
                  type: 'error'
                })

                throw response
              })
          }
        }
      }
      this.$services.user.verify.phone.send()
      let previousDialog = null
      if (this.fromDialog) {
        previousDialog = Object.assign({}, this.$store.state.dialog.dialog)
        if (previousDialog) {
          this.$store.dispatch('dialog/unshiftQueue', previousDialog)
        }
        this.$store.dispatch('dialog/closeDialog').then(() => {
          this.$store.dispatch('dialog/unshiftDialog', verifyDialog)
        })
      } else {
        this.$store.dispatch('dialog/unshiftDialog', verifyDialog)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/PhoneInput.vue